<template>
  <div id="containt" style="padding-left: 10px;">

    <div class="grid-height" style=" height: calc(100vh - -77px);">
      <vxe-grid align="center" show-overflow :stripe="true" :border="true" height="100%"
                :row-config="{ isHover: true }" ref="table-m1" v-bind="vxeOption"
                @resizable-change="$vxeTableUtil.onColumnWitchChange" @custom="$vxeTableUtil.customHandle">

        <template #form>
          <div class="clearfix screen-btns" style="margin-top: 3px;">
            <div class="fl">
              <!--              <vxe-button v-if="parts_apply_report_export" status="primary" class="button-sty" icon="el-icon-plus" @click="doExcle">导出</vxe-button>-->
            </div>
            <div class="fr">
              <vxe-button status="warning" icon="el-icon-search" class="button-sty" @click="searchEvent">搜索
              </vxe-button>
            </div>
          </div>
          <vxe-form ref="form" class="screen-box" title-width="92px" title-align="right" :data="requestParam"
          @submit="toFilterData" @keyup.enter.native="toFilterData" @reset="searchEvent">
            <vxe-form-item title="服务商:">
              <template v-slot>
                <site-search :site-id.sync="formData.siteId"
                             :show-site-name.sync="formData.siteName"
                             :show="!currentIsSite"
                />
              </template>
            </vxe-form-item>
            <vxe-form-item title="冲账日期:" field="name" style="width:25%!important;">
              <template v-slot style=" display: inline-block;width:25%!important;">
                <el-date-picker style="width: 16vw;" v-model="formData.time" type="daterange" align="right"
                                unlink-panels range-separator="-" start-placeholder="开始日期"
                                end-placeholder="结束日期" :clearable="false"
                                :picker-options="pickerOptions" value-format='yyyy-MM-dd'>
                </el-date-picker>
              </template>
            </vxe-form-item>

          </vxe-form>
        </template>
        <!-- 分页器 -->
        <template #pager>
          <pager ref="pager" :page-sizes="pageSizes" @changeTablePage="changeTablePage"></pager>
        </template>

        <template #timeSlots="{ row }">
          <!--          <span>{{row.DEGDA}} - {{row.ENDDA}}</span>-->
          <span>{{ strSplit(row.degda) }} - {{ strSplit(row.endda) }}</span>
        </template>
      </vxe-grid>
    </div>

  </div>
</template>

<script>
import {initVxeTable} from '@/const/crud/admin/table'
import pager from '@/components/pager/index.vue'
import api from "@/api/projectApi";
import OrgSearch from "@/components/formItem/orgSearch.vue";
import SitePopSearch from "@/components/formItem/sitePopSearch.vue";
import ChildSitePopSearch from "@/components/formItem/childSitePopSearch.vue";
import fileNames from "@/api/intfDownloadRecord/fileNames";
import {doCheckExcle, doDownLoadExcle} from "@/api/intfDownloadRecord/downloadRecord";
import {siteMixins} from "@/mixins/tabChang";
import {mapGetters} from "vuex";
import SiteSearch from "@/components/formItem/siteSearch.vue";


export default {
  mixins: [siteMixins],
  name: 'partsApplyReport',

  components: {SiteSearch, ChildSitePopSearch, SitePopSearch, OrgSearch, pager},
  data() {
    return {
      // parts_apply_report_export: false,

      showEdit: false,
      editViewDataUpdateFlag: false,
      activeName: 'second',
      dataId: 0,
      pageSizes: [10, 20, 100],
      requestParam: {
        searchCount: false,  // 是否分页
        current: 1,  // 当前页面
        size: 10,  // 页面数据量

        siteId: null,
        time: null,
      },
      formData: {
        siteId: null,
        siteName: null,
        time: null,
      },
      searchBarcode: '',
      searchItemCode: '',
      searchItemName: '',
      total: 0,  // 数据总数
      vxeOption: {},
      pickerOptions: {

        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },

      columns: [
        // {title: '服务商编码', field: 'KUNNR', width: 180, },
        // {title: '服务商名称', field: 'NAME1', width: 180, },
        // {title: '冲账日期', field: 'NAME1', width: 180, slots: {default: 'timeSlots'}},
        // {title: '初期可用余额', field: 'QCYUE', width: 120, },
        // {title: '本期冲账余额', field: 'CZYUE', width: 120, },
        // {title: '本期记账余额', field: 'JZYUE', width: 120, },
        // {title: '本期债务转入', field: 'ZZRJE', width: 120, },
        // {title: '本期债务传出', field: 'ZZCJE', width: 120, },
        // {title: '期末可用余额', field: 'QMYUE', width: 120, },
        {title: '服务商编码', field: 'kunnr', width: 180,},
        {title: '服务商名称', field: 'name1', width: 180,},
        {title: '冲账日期', field: 'NAME1', width: 180, slots: {default: 'timeSlots'}},
        {title: '初期可用余额', field: 'qcyue', width: 120,},
        {title: '本期冲账余额', field: 'czyue', width: 120,},
        {title: '本期记账余额', field: 'jzyue', width: 120,},
        {title: '本期债务转入', field: 'zzrje', width: 120,},
        {title: '本期债务传出', field: 'zzcje', width: 120,},
        {title: '期末可用余额', field: 'qmyue', width: 120,},
      ],
    };
  },
  watch: {
    total(newVal) {
      this.$refs.pager.tableDataTotal = newVal
    },
    activeName(newVal) {
      if (newVal === 'second' && this.editViewDataUpdateFlag) {
        this.getTableData()
      }
    }
  },
  created() {
    // this.parts_apply_report_export = this.permissions['parts_apply_report_export']this.initSearchDate()
    this.initSearchDate()
  },
  mounted() {

  },
  computed: {
    ...mapGetters(["permissions"]),
  },
  methods: {
    toFilterData() {
            this.searchEvent();
     },
    setSiteData() {
      this.formData.siteId = this.currentSiteData.id
      this.formData.siteName = this.currentSiteData.userName
      this.$objCopy(this.formData, this.requestParam)
    },

    strSplit(str) {
      let split = str.split(' ');
      return split[0]
    },

    // //导出
    // doExcle(){
    //   this.$mask.open()
    //   doCheckExcle(fileNames.applyPartsReport).then(response => {
    //     if (response.data.msg=="success"){
    //       doDownLoadExcle(api.partsApplyReport.doExcelUrl, this.requestParam).then(res => {
    //         this.$mask.close()
    //         this.$message({
    //           type: res.data.type,
    //           message: res.data.content
    //         });
    //       }).catch(() => {
    //         this.$mask.close()
    //       })
    //     }else{
    //       this.$mask.close()
    //       this.$message({
    //         type: "error",
    //         message: response.data.msg
    //       });
    //     }
    //   }).catch(() => {
    //     this.$mask.close()
    //   })
    // },
    // 初始化搜索时间
    initSearchDate() {
      let end = new Date();
      let start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
      this.formData.time = [start, end]
      this.requestParam.time = [start, end]
    },
    mergeRowMethod({row, _rowIndex, column, visibleData}) {
      // const fields = ['applyQty', 'checkQty', 'collectQty', 'outQty', 'getQty']
      const cellValue = row[column.property]
      // if (cellValue && !fields.includes(column.property)) {
      const prevRow = visibleData[_rowIndex - 1]
      let nextRow = visibleData[_rowIndex + 1]
      if (prevRow && prevRow[column.property] === cellValue) {
        return {rowspan: 0, colspan: 0}
      } else {
        let countRowspan = 1
        while (nextRow && nextRow[column.property] === cellValue) {
          nextRow = visibleData[++countRowspan + _rowIndex]
        }
        if (countRowspan > 1) {
          return {rowspan: countRowspan, colspan: 1}
        }
      }
      // }
    },
    // 刷新
    flushed() {
      this.$refs['table-m1'].commitProxy('reload');
    },

    // 加载table数据
    getTableData() {
      let tableOption = {
        vue: this,
        tableRef: 'table-m1',
        path: api.sitePartsAccountReport.getPage,
        param: this.requestParam,
        method: 'post',
        columns: this.columns
      };
      this.vxeOption = initVxeTable(tableOption);
      this.flushed()
    },

    // 分页功能
    changeTablePage(page, flag) {
      this.requestParam.size = page.pageSize
      this.requestParam.current = page.currentPage
      this.requestParam.searchCount = flag
      this.getTableData()
    },

    // 搜索
    searchEvent() {
      this.$objCopy(this.formData, this.requestParam)
      this.$refs.pager.clearStoreTableDataTotal()
      this.requestParam.current = 1
      this.requestParam.searchCount = false
      this.$refs.pager.reset()  // 重置分页器
      this.flushed()
    },

    // 重置
    resetEvent() {

      this.requestParam.current = 1
      this.$refs.pager.reset()  // 重置分页器
      this.flushed()
    },

    // 新增
    openEditDialog(id) {
      console.log(id)
      this.dataId = !id || typeof id == 'object' ? 0 : id;
      this.activeName = 'first';
      this.$openEditView('showEdit');
    },

    editViewDataUpdate() {
      this.editViewDataUpdateFlag = true;
    },
  }
};
</script>
<style lang="scss">
/* 注意此处不能有scoped 否则样式无法生效 */
.el-cascader-panel {
  .el-radio__inner {
    border: 0px;
    background: transparent;
  }

  .el-radio__input.is-checked .el-radio__inner {
    background: none;
  }

  .el-radio {
    height: 100%;
    width: 150px;
    position: absolute;
    z-index: 10;
  }
}


</style>
